import * as FileSaver from 'file-saver'
import moment from 'moment'
import * as XLSX from 'xlsx-js-style'
import { styleTableSheet } from 'utils/excelStyle'
import { store } from 'app/store'
import { projectsMenuListApiSlice } from './projectsMenuListApiSlice'

export const handleDownloadExcel = (
  items,
  totalItems,
  setIsDownload,
  setFirstRows,
  setTotalRows,
  columns,
  name
) => {
  setIsDownload(false)
  setFirstRows(0)
  setTotalRows(0)

  setTimeout(() => {
    setIsDownload(true)
    setFirstRows(0)
    setTotalRows(totalItems)

    const fileType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    const bookType = 'xlsx'
    let count = 2

    const chunkSize = Math.max(Math.floor(totalItems * 0.1), 100)

    const validColumns = columns.filter((col) => col.name && typeof col.name === 'object')

    const exportHeader = validColumns.map((col) => {
      if (col.selector === 'goals_summary') return 'Goals (Unit)'
      return col.name?.props?.children ?? ''
    })

    const ws = XLSX.utils.book_new()
    XLSX.utils.sheet_add_aoa(ws, [exportHeader])

    const processChunk = async (start) => {
      if (start >= totalItems) {
        setFirstRows(totalItems)
        setTimeout(() => {
          styleTableSheet(ws)
          const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
          const excelBuffer = XLSX.write(wb, { bookType, type: 'array' })
          const finalData = new Blob([excelBuffer], { type: fileType })

          FileSaver.saveAs(
            finalData,
            `Projects_${name}_${moment().format('YYYY-MM-DD')}.xlsx`,
          )

          setTimeout(() => {
            setIsDownload(false)
          }, 2000)
        }, 500)

        return
      }

      // extract directly from items because it already has all fetched data
      const currentItems = items?.slice(start, start + chunkSize) || [];
      const chunk = [];

      for (let i = 0; i < currentItems.length; i++) {
        const row = currentItems[i];
        let cachedSummary = undefined;

        try {
          const selectSummary = projectsMenuListApiSlice.endpoints.fetchProjectSummaryById.select({ projectId: row.id });
          const { data } = selectSummary(store.getState());
          cachedSummary = data;
        } catch (e) {
          console.error("Cache read error", e);
        }

        if (!cachedSummary) {
          try {
            const response = await store.dispatch(
              projectsMenuListApiSlice.endpoints.fetchProjectSummaryById.initiate({ projectId: row.id })
            );
            if (response?.data) {
              cachedSummary = response.data;
            }
          } catch (e) {
            console.error('Failed to fetch summary', e);
          }
        }

        const mappedRow = validColumns.map((col) => {
          try {
            // Some selectors are string 'createdAt', some are functions
            let value = '-'
            if (typeof col.selector === 'function') {
              if (col.selector.toString().includes('ProjectSummaryCell')) {
                  value = '-'
              } else {
                  value = col.selector(row)
              }
            } else if (typeof col.selector === 'string') {
              if (col.selector === 'parentProject') {
                value = row?.parentProject?.label || '-'
              } else if (col.selector === 'goals_summary') {
                value = cachedSummary?.totalGoal ?? '-'
              } else if (col.selector === 'completion_summary') {
                value = cachedSummary?.totalInventory ?? '-'
              } else if (col.selector === 'percentage_summary') {
                value = cachedSummary?.pctgVsGoal ?? '-'
              } else if (col.selector === 'createdAt') {
                value = row.createdAt ? moment(row.createdAt).format('YYYY-MM-DD') : '-'
              } else {
                value = row[col.selector]
              }
            }
            if (typeof value === 'string') {
              return value.replace(/<br\s*\/?>/g, '\n')
            }
            return value ?? '-'
          } catch (e) {
            return '-'
          }
        })
        chunk.push(mappedRow)
      }

      XLSX.utils.sheet_add_json(ws, chunk, {
        origin: `A${count}`,
        skipHeader: true,
      })
      count += chunk.length
      setFirstRows(start + chunk.length)

      setTimeout(() => processChunk(start + chunkSize), 300)
    }

    processChunk(0)
  }, 300)
}